











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.User.ChangePasswordWithTokenCommand')
    
    export class ChangePasswordWithTokenCommand {
        constructor( token: string, password: string ) {
            
                this.token = token;
            
                this.password = password;
            
        }

        
            public token: string;
        
            public password: string;
        
    }

    export interface IChangePasswordWithTokenCommand {
        
            token: string;
        
            password: string;
        
    }

    export async function changePasswordWithToken( command: ChangePasswordWithTokenCommand ): Promise<CommandResult<void>>
    export async function changePasswordWithToken( { token, password }: IChangePasswordWithTokenCommand ): Promise<CommandResult<void>>
    export async function changePasswordWithToken( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof ChangePasswordWithTokenCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new ChangePasswordWithTokenCommand( model['token'], model['password'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace ChangePasswordWithTokenCommand.ExtraneousTypes {
        

        
    }

